












import { Component, Prop, Vue } from 'vue-property-decorator';
import payment from '@/store/modules/payment';
import store from '@/store';
import checkout from '@/store/modules/checkout';

@Component({})
export default class PaypalButton extends Vue {
    @Prop() public buttonId!: string;

    get tokenization(): any {
        return payment.additionalData.paypal_tokenization;
    }

    get shouldShowSaveInVault(): boolean {
        return this.ppConfigs.vault_enabled && !this.ppConfigs.vault_id && checkout.selectedPayment === 'wf_paypal';
    }

    get ppConfigs(): any {
        return store.state.options.payment.paypal;
    }
}
